export const profileSurveyData = {
  "agencyType": "",
  
  "registeredBusinessName": "",
  "tradingName": "",
  // "sizeOfOrganization": "", //Small, Medium, Large
  "typeOfBusiness": "",
  "goalsWithMiles": "",
  "interestedIn": "", //Flight, Stay, Tour, Protection

  "address": {
    'location': [],
    "businessLocation": "",
    "lga": "",
    "addressOne": "",
    "addressTwo": "",
    "additionalInfo": "",
  },
  "businessEmail": '',
  "businessPhone": '',
  "businessLocation": '',
  'position': '',

	"agencyURL":"",
	"agencyLogo":"",
  "legalInfo": {
    "companyNumber": '',
    "country": '',
    "taxIdentification": '',
  },
  "contact": {
    "firstName": '',
    "lastName": '',
    "position": '',
    "email": '',
  }
}